import {Component, Input, OnChanges} from '@angular/core';

@Component({
  selector: 'app-error-message',
  templateUrl: './error-message.component.html',
  styleUrls: ['./error-message.component.scss'],
})
export class ErrorMessageComponent implements OnChanges {
  @Input() error;
  @Input() idPrefix = '';
  message = '';

  ngOnChanges(): void {
    this.message = this.error && this.error.message ? this.error.message : this.error ? this.error : '';
  }
}
